import { useMemo } from 'react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import { clusterApiUrl } from '@solana/web3.js';
import '@solana/wallet-adapter-react-ui/styles.css';

/**
 * Provides Solana wallet adapter context for the entire app.
 * @param {{children: import('react').ReactNode}} props
 */
export function AppWalletProvider({ children }) {
  const networkName = String(
    process.env.REACT_APP_SOLANA_CLUSTER || process.env.REACT_APP_SOLANA_NETWORK || 'mainnet-beta'
  ).toLowerCase();

  const network = useMemo(() => {
    if (networkName === 'devnet') {
      return WalletAdapterNetwork.Devnet;
    }
    if (networkName === 'testnet') {
      return WalletAdapterNetwork.Testnet;
    }
    return WalletAdapterNetwork.Mainnet;
  }, [networkName]);

  const endpoint = useMemo(() => {
    const customRpc = String(process.env.REACT_APP_SOLANA_RPC_URL || '').trim();
    return customRpc || clusterApiUrl(network);
  }, [network]);

  const wallets = useMemo(
    () => [new PhantomWalletAdapter(), new SolflareWalletAdapter({ network })],
    [network]
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
